document.addEventListener("DOMContentLoaded", function () {
  var btn = document.getElementById("toggle-categories");
  if (!btn) return;

  var sectionWrapper = btn.closest(".shopify-section");
  if (!sectionWrapper) return;

  var extraSection = sectionWrapper.nextElementSibling;
  if (!extraSection) return;

  // ocultar la multicolumna extra al cargar
  extraSection.style.display = "none";

  btn.addEventListener("click", function () {
    var isHidden = extraSection.style.display === "none";

    extraSection.style.display = isHidden ? "block" : "none";
    btn.textContent = isHidden
      ? "Ver menos categorías"
      : "Ver más categorías";
  });
});
